import { Component, OnInit, ViewChild, Input, Output, EventEmitter } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { Store } from '@ngrx/store';
import { AppState } from '../../../store/app-state';
import { FormBaseComponent } from '../../core/component/form-base/form-base.component';
import { CommerceGeneralModel } from '../../model/CommerceGeneralModel';
import { ValidatorService } from 'app/core/service/app/validator.service';
import { CatalogueService } from 'app/core/service/core/cataloque.service';
import { AccountService } from 'app/core/service/app/account.service';
import { CommerceService } from 'app/core/service/app/commerce.service';


@Component({
  selector: 'app-commerce-info-form',
  templateUrl: './commerce-info-form.component.html'//,
  //styleUrls: ['./commerce-info-form.component.scss']
})
export class CommerceInfoFormComponent extends FormBaseComponent<any> implements OnInit {

  ownerList$
  addressTimeList$;
  catPersonas: any;


  @Input() showLogin = true;

  @Output() infoCommerceCompleted = new EventEmitter<number>();

  constructor(
    public validatorService: ValidatorService,
    private catalogo: CatalogueService,
    private accountService: AccountService,
    private commerceService: CommerceService
    ) {
    super();
  }

  ngOnInit() {
    this.init(true);
    
    this.catalogo.getTipoPersona().then(result => {
      this.catPersonas = result;
    });
  }

  template() {
    this.form.addControl('commerceName', new FormControl(null, Validators.required));
    this.form.addControl('legalStructure', new FormControl(null, Validators.required));
  }

  legalStructureChange()
  {
    this.commerceService.saveWizardData()
      .then(result=>{
        this.accountService.refresh();
      });
  }

}












// WEBPACK FOOTER //
// ./src/app/form/form/commerce-info-form/commerce-info-form.component.ts